export const formatDateTime = (
  value: any,
  options?: { dateOnly?: Boolean }
) => {
  if (value) {
    const { dateOnly } = options ?? {};
    const date = new Date(value);
    const myTimeZone = 9; //  UTC +9
    date.setTime(date.getTime() + myTimeZone * 60 * 60 * 1000);
    const isoDate = date.toISOString();
    const time12hour = date.toLocaleTimeString('en-US', {
      timeZone: 'UTC',
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    if (dateOnly) {
      return `${isoDate.substr(0, 10).replaceAll('-', '.')}`;
    }
    return `${isoDate.substr(0, 10).replaceAll('-', '.')} ${time12hour}`;
  }
};
